import {
  Filter
} from '../common/filter';
require('./view-tabs.component.scss');

class ViewTabsController {
  constructor(
    $scope,
    $q,
    $element,
    FilterEditorService,
    CurrentFilterService,
    PermissionService,
    LayoutService,
    RouterService,
    ErrorHandlerService,
    AggregateDataService,
  ) {
    this.$scope = $scope;
    this.$q = $q;
    this.$element = $element;
    this.FilterEditorService = FilterEditorService;
    this.CurrentFilterService = CurrentFilterService;
    this.permission = PermissionService;
    this.router = RouterService;
    this.layout = LayoutService;
    this.ErrorHandlerService = ErrorHandlerService;
    this.AggregateDataService = AggregateDataService;
    this.layout.openAll = false;
    this.limit = '';
    this.limitTitle = '';
    this.typeDim = 'agent_eventtype@default:agent_eventtype';
    this.$scope.$watch('$ctrl.filter.customLimit', () => {
      if (!this.filter) return;
      this.limitTitle = gettext('Ограничение записей в запросе: ') + this.filter.limit;
      this.customLimit = this.filter.customLimit;
    });
  }

  get showWords() {
    return this.$element.width() > 638;
  }

  setThumblistFilters() {
    let typeCount = 0;
    this.filter.filters = this.filter.filters.filter(f => {
      const goodType = f.dimension === this.typeDim &&
        (f.value === '4' || f.value === '20');
      if (goodType) typeCount += 1;
      return goodType || f.dimension !== this.typeDim;
    });
    if (!typeCount) {
      this.filter.cleanFilter('agent_eventtype@default:agent_eventtype');
      this.filter.addFilter('agent_eventtype@default:agent_eventtype', '4', gettext('Снимок экрана'));
      this.filter.addFilter('agent_eventtype@default:agent_eventtype', '20', gettext('Снимок с веб-камеры'));
      this.CurrentFilterService.rebuildVisibleDimensions();
      this.router.filterChanged();
    }
  }

  pressEnter(event) {
    if (event.keyCode === 13) {
      this.updateCustomLimit();
    }
  }

  set customLimit(limit) {
    const l = parseInt(limit, 10);
    if (isNaN(l) || !l) this.limit = '';
    else this.limit = l;
  }

  get customLimit() {
    return this.limit;
  }

  updateCustomLimit() {
    if (this.isFilterEdit) this.filter.customLimit = this.customLimit;
    else this.router.setLimit(this.limit);
  }

  nop(event) {
    event.preventDefault();
    event.stopPropagation();
  }

  get isFilterEdit() {
    return this.router.isFilterEditModal;
  }

  get isContainer() {
    return this.filter && this.filter.id && this.filter.isContainer;
  }

  get filter() {
    // return this.CurrentFilterService.filter;
    return this.isFilterEdit && this.filterData ? this.filterData.filter : this.CurrentFilterService.filter;
  }

  get mode() {
    return this.isFilterEdit && this.filterData ? this.filterData.filter.mode : this.router.mode;
  }

  get isShowLimit() {
    return true;
  }

  get dropdownStyle() {

    return {
      'overflow': 'auto',
      'max-height': `${this.$element.parent().height() - 50}px`,
    };
  }

  renewFilter() {
    this.CurrentFilterService.reset();
    Object.keys(this.filter).map(k => {
      if (k != 'filters') delete this.filter[k];
    });
    Object.assign(this.filter, new Filter());
    this.CurrentFilterService.setFilterName(this.filter);
  }

  get frameUrl() {
    return this.CurrentFilterService.frameUrl;
  }

  setMode(mode) {
    if (this.isContainer || this.frameUrl) this.renewFilter();
    this.filter.removeContent_type();
    this.filter.setMode(mode);
    this.router.filter = this.filter;
  }

  get showFacts() {
    return !!(this.permission.fact && this.filter && !this.filter.send_threshold);
  }

  get showAnalyses() {
    return this.permission.analyses;
  }

  get showTimeTracking() {
    return !!(this.permission.schedule && this.filter && !this.filter.send_threshold);
  }

  get showReports() {
    return !!(this.permission.reports && this.filter && !this.filter.send_threshold);
  }


  get listType() {
    return this.isFilterEdit && this.filterData ? this.filterData.filter.listType : this.router.listType;
  }

  setList(listType) {
    if (this.isContainer || this.frameUrl) this.renewFilter();
    if (listType === 'thumblist') this.setThumblistFilters();
    this.filter.listType = listType;
    this.filter.mode = 'explore';
    this.filter.removeContent_type();
    this.router.filter = this.filter;
  }

  setChatViewer() {
    const typeDim = 'agent_eventtype@default:agent_eventtype';
    this.filter.cleanFilter(typeDim);
    this.filter.addFilter(typeDim, '8', gettext('Интернет-пейджер'));
    this.filter.addFilter(typeDim, '9', gettext('Почта'));
    this.setList('chat-viewer');
  }

  generateReport(url) {
    if (this.isContainer) this.renewFilter();
    if (this.isFilterEdit && this.filterData) {
      this.setMode('reports');
      this.filterData.filter.url = url;
    } else this.router.generateReport(url);
  }

  openAll() {
    if (this.layout.openAll < 0) this.layout.openAll = 0;
    this.layout.openAll += 1;
  }

  closeAll() {
    if (this.layout.openAll > 0) this.layout.openAll = 0;
    this.layout.openAll -= 1;
  }

  // toggleEditDasboard() {
  //   this.router.isEditDasboard = !this.router.isEditDasboard;
  // }

  toggleEditCatalog() {
    this.layout.editCatalog = !this.layout.editCatalog;
  }

  get isEditCatalog() {
    return !!this.layout.editCatalog;
  }

  newFilterToDasboard() {
    const filter = this.CurrentFilterService.createNewFilter();
    filter.cardWidth = 12;
    filter.cardHeight = 6;
    this.router.isEditDasboard = true;
    return this.$q.resolve()
      .then(() => {
        return this.FilterEditorService.editModal({
          filter,
          asNew: true,
          selectFilter: false,
        });
      })
      .then(newFilter => {});
  }
}

export const ViewTabsComponent = {
  template: require('./view-tabs.component.html'),
  bindings: {
    filterData: '<',
  },
  controller: ViewTabsController,
};



// WEBPACK FOOTER //
// ./src/view/view-tabs.component.js